/**
 * Compatibility shim for vee-validate v2/v3 ValidationObserver.
 * In vee-validate v4, this was replaced by <Form>.
 * This shim provides the old slot API ({ passes, invalid }) so existing
 * templates work without modification. Client-side validation is skipped;
 * server-side validation still applies.
 */
export default {
	name: 'ValidationObserver',
	inheritAttrs: false,
	setup(props, { slots, expose }) {
		const validate = () => Promise.resolve({ valid: true });
		const reset = () => {};

		expose({ validate, reset });

		return () => {
			// passes(fn) mirrors the old API: validate then call fn
			// In the shim we skip validation and call fn directly
			const passes = fn => fn();
			return slots.default?.({
				passes,
				handleSubmit: passes,
				invalid: false,
				valid: true,
				dirty: false,
				touched: false,
				pending: false,
				errors: {},
				validate,
				reset,
			});
		};
	},
};
